import { get } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from '../Actions/Loader.action';

export const PAYMENTS_RECEIVE = 'PAYMENTS_RECEIVE';
export const PAYMENTS_ERROR = 'PAYMENTS_ERROR';

export const receive = (data) => ({
    type: PAYMENTS_RECEIVE,
    payload: {
        list: data,
    },
});

export const setError = error => ({
    type: PAYMENTS_ERROR,
    payload: {
        error,
    },
});

export const query = (fromDate, toDate) => (dispatch) => {
    dispatch(showLoader());
    return get('api/erp/paymentsNested?fromDate=' + fromDate + '&toDate=' + toDate)
        .then(response => response.json())
        .then((result) => {
            dispatch(receive(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};